<template>
  <Drawer
    title="请选择导出的字段"
    v-model="orgExModal"
    width="600"
    :mask-closable="true"
    :styles="styles"
    @on-close="orgExModalCancel"
    class="export-model"
  >
    <div class = "export-model-content">
      <div class = "export-model-main">
        <Form :label-width="100" ref="exportFormData" :model="exportFormData">
          <FormItem>
            <Checkbox
              :indeterminate="indeterminate1"
              :value="checkAllColmus"
              @click.prevent.native="handleCheckAllColmus"
            >全选</Checkbox>
            <CheckboxGroup
              v-model="exportFormData.exportColums"
              class="checkBoxFlex"
              @on-change="checkAllGroupChange"
            >
              <div v-for="(item, index) in exportColumsList" :key="index" class="itemZ">
                <Tooltip
                        max-width="305"
                        width="305"
                        placement="top-start"
                        transfer
                        :content=item
                >
                  <Checkbox :label="item" :key="item">{{item.length>25?item.substring(0,25)+"...":item}}</Checkbox>
                </Tooltip>
              </div>
              <!--<Checkbox :label="item" :key="item" v-for="item in exportColumsList"></Checkbox>-->
            </CheckboxGroup>
          </FormItem>
        </Form>
      </div>
      <div class="button-drawer-footer">
        <Button class="btn-cancel" @click="orgExModalCancel">取消</Button>
        <Button type="primary" @click="exportSubmit()">导出</Button>
      </div>
    </div>
  </Drawer>
</template>

<script>
export default {
  props: {
    viewId: String,
    objectId: String,
    tableSelection: Array,
    handleDivCon: Boolean
  },
  data() {
    return {
      exportFieldList: [],
      exportColumsList: [],
      exportFormData: {
        exportColums: []
      },
      checkAllColmus: false,
      indeterminate1: false,
      orgExModal: false
    }
  },
  watch: {
    // viewId: {
    //   handler(newValue) {
    //     this.searchExportColumns(newValue)
    //   },
    //   immediate: true
    // }
  },
  mounted(){
    console.log(this.$parent.$refs)
  },
  methods: {
    open() {
      console.log(this.viewId)
      this.searchExportColumns(this.viewId)
      this.orgExModal = true
    },
    orgExModalCancel() {
      this.indeterminate1 = false
      this.checkAllColmus = false
      this.exportFormData.exportColums = []
      this.orgExModal = false
    },
    handleCheckAllColmus() {
      if (this.indeterminate1) {
        this.checkAllColmus = false
      } else {
        this.checkAllColmus = !this.checkAllColmus
      }
      this.indeterminate1 = false
      if (this.checkAllColmus) {
        this.exportFormData.exportColums = this.exportColumsList
      } else {
        this.exportFormData.exportColums = []
      }
    },
    checkAllGroupChange(data) {
      if (data.length === this.exportColumsList.length) {
        this.indeterminate1 = false
        this.checkAllColmus = true
      } else if (data.length > 0) {
        this.indeterminate1 = true
        this.checkAllColmus = false
      } else {
        this.indeterminate1 = false
        this.checkAllColmus = false
      }
    },
    exportSubmit() {
      let checkedList = []
      let operFields = ''
      if (this.exportFormData.exportColums.length <= 0) {
        this.$Message.error('请选择导出列')
        return
      } else {
        this.exportFormData.exportColums.forEach(temp => {
          this.exportFieldList.forEach(item => {
            if (item.fieldName === temp) {
              checkedList.push(item.fieldCname)
              return
            }
          })
        })
        if (checkedList.length === this.exportFieldList.length) {
          operFields = checkedList.join(',')
        } else {
          operFields = checkedList.join(',')
        }
         console.log(operFields);
      }
      // 调用选中导出或默认导出接口
      var params = {}
      let queryParams = {whereOf: "",whereOfNum: ""}
      if (this.handleDivCon) {
        // console.log('选中行导出');
        let custList = []
        this.tableSelection.forEach(item => {
          custList.push(item.mt_id)
        })
        let mtString = custList.join(',')
        params = {
          selectActionData: {
            Head: {
              method: 'select',
              version: 'v1.0'
            },
            Data: [
              {
                OBJECT_NAME: 'sccm_cust_info',
                whereOf: `mt_id in (${mtString})`,
                operFields: operFields,
                moId: this.objectId,
                page: {
                  pageNumber: 1,
                  pageSize: 0
                },
                orderBy: ''
              }
            ]
          },
          searchOrderViewId: this.viewId,
          searchOrderType: 'flow'
        }
      } else {
        // console.log('默认导出');
        params = {
          selectActionData: {
            Head: {
              method: 'select',
              version: 'v1.0'
            },
            Data: [
              {
                OBJECT_NAME: 'sccm_cust_info',
                whereOf: '',
                operFields: operFields,
                moId: this.objectId,
                page: {
                  pageNumber: 1,
                  pageSize: 0
                },
                orderBy: ''
              }
            ]
          },
          searchOrderViewId: this.viewId,
          searchOrderType: 'flow'
        }
        if(this.$parent&&this.$parent.$refs['mixForm']){
          let whereParam = this.$parent._makeQuerySql(this.$parent.$refs['mixForm'].formDatas);
          if(whereParam.indexOf("@")!=-1){
              let whereArr = whereParam.split("@");
              queryParams.whereOf = whereArr[0];
              queryParams.whereOfNum = whereArr[1];
          }else{
              queryParams.whereOf = whereParam;
              queryParams.whereOfNum = "";
          }
        }
      }
      // console.log(params);
      
      this.$http
        .get('/scmd/export/exportObjectData', {
          params: { 
            orderString: JSON.stringify(params),
            ...queryParams
          }
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            this.orgExModalCancel()
            this.$Message.success('导出成功')
          } else {
            this.$Message.error('导出失败')
          }
        })
    },
    searchExportColumns(viewId) {
      // console.log(viewId)
      this.$http
        .get('/scmd/fields/getFieldAndDataListByViewId?viewId=' + viewId)
        .then(response => {
          if (response.data.returnCode === 0) {
            let fieldList = response.data.bean.fieldList
            // console.log(fieldList);
            if (!response.data.bean.mtIdShow) {
              let fieldCname = 'mt_id'
              fieldList = fieldList.filter(obj => {
                if('15'=== obj.fieldType || '')
                  return false
                return fieldCname !== obj.fieldCname
              })
            }
            if (!response.data.bean.businessTypeShow) {
              let fieldCname = 'business_type'
              fieldList = fieldList.filter(obj => {
                return fieldCname !== obj.fieldCname
              })
            }
            this.exportFieldList = fieldList
            this.exportColumsList = fieldList.map(item => {
              // return {
              //     label: item.fieldName,
              //     value: item.fieldCname
              // }
              return item.fieldName
            })
            console.log(this.exportColumsList)
            // console.log(this.exportColumsList);
          } else {
            this.$Message.error('查询失败!')
          }
        })
    }
  }
}
</script>

<style scoped lang = "less">
.export-model-content /deep/ .ivu-form-item-content{
  margin:0!important;
  padding-left:16px;
}
.checkBoxFlex{
    display: flex;
    flex-direction: column;
}
.export-model-content{
  display:flex;
  flex-direction:column;
  height:100%;
  .export-model-main{
    flex:1;
    overflow-y:auto;
    padding:10px 0;
  }
  .button-drawer-footer{
    height:52px;
    background:#fff;
  }
}

</style>